import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/universal-city")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Universal City, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Universal City & Bexar County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Universal City, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Universal City and Bexar County.",
      keywords: "awnings Universal City, awning company Universal City, custom awnings Universal City, sail shades Universal City, patio covers Universal City, pergola covers Universal City, metal awnings Universal City, canvas awnings Universal City, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Universal City", "Bexar County"),
  }),
  component: () => <CityHomePage city="Universal City" region="Bexar County" />,
});
